export default "__VITE_ASSET__BZAVeYY$__"